import enLocale from './en_us'
import zhLocale from './zh_cn'
import tcLocale from './zh_tc'
import initI18n from '../tools'

export const i18n = initI18n({ zhLocale, tcLocale, enLocale })
